// Utility to manage document titles consistently across the application
export const setDocumentTitle = (screenName = '', eventName = '') => {
  const baseTitle = eventName || 'Event App';
  const suffix = screenName ? ` - ${screenName}` : '';
  document.title = `${baseTitle}${suffix}`;
};